import GeneralProperties from '../../core/ComponentDocs'

export default {
    documentation : {
        ...GeneralProperties.documentation,
        indicador : {
            hintTitle: "",
            hintText:"Qual dashboard padrão mostrar: 'vendas', 'crm', 'agenda' ou 'inteligenciamercado'. O sistema usa o dashboard instalado para este ambiente (aba Indicadores do painel)."
        },
        metabaseDashboardId : {
            hintTitle: "",
            hintText:"Formato antigo: id do dashboard no Metabase. Use 'indicador'; o id só é aceito se o dashboard for deste ambiente."
        },
        theme : {
            hintTitle: "",
            hintText:"Tema do dashboard: 'transparent', 'light' ou 'night'."
        },
        bordered : {
            hintTitle: "",
            hintText:"Exibe a borda ao redor do dashboard."
        },
        titled : {
            hintTitle: "",
            hintText:"Exibe o título do dashboard."
        },
    }
}
